import React from 'react';
import { ArrowUp, ArrowDown, Minus, BoxIcon } from 'lucide-react';
import { Card, CardContent } from './Card';
import { cn } from '../../lib/utils';
export type IconColor = 'blue' | 'green' | 'red' | 'amber' | 'purple';
interface KPICardProps {
  title: string;
  value: string;
  icon: BoxIcon;
  iconColor?: IconColor;
  trend?: {
    value: string;
    direction: 'up' | 'down' | 'neutral';
  };
  description?: string;
  className?: string;
  loading?: boolean;
}
const colorStyles = {
  blue: 'bg-blue-50 text-blue-600 border-l-blue-500',
  green: 'bg-green-50 text-green-600 border-l-green-500',
  red: 'bg-red-50 text-red-600 border-l-red-500',
  amber: 'bg-amber-50 text-amber-600 border-l-amber-500',
  purple: 'bg-purple-50 text-purple-600 border-l-purple-500'
};
export function KPICard({
  title,
  value,
  icon: Icon,
  iconColor = 'blue',
  trend,
  description,
  className,
  loading = false
}: KPICardProps) {
  if (loading) {
    return <Card className={cn('animate-pulse', className)} data-id="element-338">
        <CardContent className="p-6" data-id="element-339">
          <div className="flex items-center justify-between" data-id="element-340">
            <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-341"></div>
            <div className="h-8 w-8 bg-gray-200 rounded-full" data-id="element-342"></div>
          </div>
          <div className="mt-4 h-8 w-32 bg-gray-200 rounded" data-id="element-343"></div>
          <div className="mt-2 h-4 w-40 bg-gray-200 rounded" data-id="element-344"></div>
        </CardContent>
      </Card>;
  }
  return <Card className={cn('hover:shadow-md transition-all duration-300 animate-fade-in h-full border-l-[3px] overflow-hidden', colorStyles[iconColor].split(' ').pop(),
  // Get the border color class
  className)} data-id="element-345">
      <CardContent className="p-5 flex flex-col justify-between h-full" data-id="element-346">
        <div className="flex items-center justify-between space-y-0 pb-2" data-id="element-347">
          <h3 className="text-sm font-medium text-gray-500 tracking-wide" data-id="element-348">
            {title}
          </h3>
          <div className={cn('p-2 rounded-full', colorStyles[iconColor].split(' ').slice(0, 2).join(' '))} data-id="element-349">
            <Icon className="h-4 w-4" data-id="element-350" />
          </div>
        </div>
        <div data-id="element-351">
          <div className="flex items-baseline mt-3" data-id="element-352">
            <div className="text-3xl font-bold text-gray-900 tracking-tight" data-id="element-353">
              {value}
            </div>
          </div>

          <div className="flex items-center mt-2 gap-2" data-id="element-354">
            {trend && <div className={cn('flex items-center text-xs font-medium px-2 py-0.5 rounded-full', trend.direction === 'up' && 'bg-green-50 text-green-700', trend.direction === 'down' && 'bg-red-50 text-red-700', trend.direction === 'neutral' && 'bg-gray-50 text-gray-600')} data-id="element-355">
                {trend.direction === 'up' && <ArrowUp className="h-3 w-3 mr-1" data-id="element-356" />}
                {trend.direction === 'down' && <ArrowDown className="h-3 w-3 mr-1" data-id="element-357" />}
                {trend.direction === 'neutral' && <Minus className="h-3 w-3 mr-1" data-id="element-358" />}
                {trend.value}
              </div>}
            {description && <p className="text-xs text-gray-400" data-id="element-359">{description}</p>}
          </div>
        </div>
      </CardContent>
    </Card>;
}